import React, {Suspense, lazy} from 'react';
import {Routes, Route} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {Provider} from 'react-redux';
import {store} from './redux/store';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import LoadingScreen from './components/LoadingScreen';
import Profile from './pages/Profile';
import {Toaster} from 'react-hot-toast';

// Lazy load components
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Cards = lazy(() => import('./pages/Binder'));
const Decks = lazy(() => import('./pages/Decks'));
const DeckDetails = lazy(() => import('./pages/DeckDetails'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const OauthSuccess = lazy(() => import('./pages/OauthSuccess'));
const GoogleAdsExample = lazy(() => import('./pages/GoogleAdsExample'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));

const queryClient = new QueryClient();

function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<LoadingScreen/>}>
            <Routes>
              <Route element={<Layout/>}>
                <Route path='/' element={<Home/>}/>
                <Route path='/login' element={<Login/>}/>
                <Route path='/register' element={<Register/>}/>
                <Route path='/reset-password/:uid/:token' element={<ResetPassword/>}/>
                <Route path='/decks' element={<Decks/>}/>
                <Route path='/blog' element={<Blog/>}/>
                <Route path='/blog/:id' element={<BlogDetail/>}/>
                <Route path='/deck/:id' element={<DeckDetails/>}/>
                <Route path='/cards' element={<Cards/>}/>
                <Route path='/oauth-success' element={<OauthSuccess/>}/>
                <Route path='/profile/:username' element={<Profile/>}/>
                <Route path='/terms' element={<Terms/>}/>
                <Route path='/privacy' element={<Privacy/>}/>
                <Route path='/google-ads-example' element={<GoogleAdsExample/>}/>
                <Route path='*' element={<NotFound/>}/>
              </Route>
            </Routes>
            <Toaster position='top-right'/>
          </Suspense>
        </QueryClientProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
